import { render, staticRenderFns } from "./Offer-new.vue?vue&type=template&id=1271f501"
import script from "./Offer-new.vue?vue&type=script&lang=js"
export * from "./Offer-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports